var utils = {};

utils.ripple = function ripple(event, $this) {
	event = event || window.event;
	var x = event.pageX || event.originalEvent.pageX;
	var y = event.pageY || event.originalEvent.pageY;
	var wx = $this.width();
	x = x - $this.offset().left - wx / 2;
	y = y - $this.offset().top - wx / 2;
	var span = '<div class="ripple"></div>';
	$this.prepend(span);
	$(".ripple").css({
		width: wx,
		height: wx,
		top: y + "px",
		left: x + "px"
	}).addClass("rippleEffect");
	$(document).one("webkitAnimationEnd animationend", ".ripple", function() {
		$(".ripple").remove();
	});
};

utils.getZero = function getZero(d) {
	if(d < 10) {
		d = '0' + d;
	}
	return d;
};

utils.checkMath = function checkMath(d) {
	if(d >= 1000) {
		var num = d / 1000;
		num = num.toFixed(1);
		num += "k";
		return num;
	} else if(d == null || d == undefined) {
		d = 0;
	}
	return d;
};

// 格式化日期
utils.checkDate = function checkDate(d) {
	var cur = new Date();
	cur = cur.getTime();
	var oldDate = new Date(d).getTime();
	var hour = 3600 * 1000;
	var passDate = cur - oldDate;
	var now = 0;
	if(passDate < hour * 24) {
		var dd = passDate / hour;
		if(dd < 1) {
			now = Math.round(passDate / hour * 60) == 0 ? 1 : Math.round(passDate / hour * 60);
			now += "分钟前";
		} else {
			if(Math.round(passDate / hour) == 24) {
				now = "1天前";
			} else {
				now = Math.round(passDate / hour) + "小时前";
			}
		}
	} else if(passDate >= hour * 24 && passDate < hour * 24 * 7) {
		now = (Math.floor(passDate / 24 / hour) + "天前");
	} else {
		now = d.split(/\s+/)[0];
	}
	return now;
};

utils.htmlspecialchars_decode = function htmlspecialchars_decode(str) {
	str = str.replace(/&amp;/g, '&');
	str = str.replace(/&quot;/g, "'");
	str = str.replace(/&quot;/g, '"');
	return str;
};

utils.code_format = function code_format(content) {
	content = content.replace(/<input/g, "<<span class='code_html'>input</span>");
	content = content.replace(/<\/input/g, "<<span>/</span><span class='code_html'>input</span>");
	content = content.replace(/<button/g, "<<span class='code_html'>button</span>");
	content = content.replace(/<\/button/g, "<<span>/</span><span class='code_html'>button</span>");
	content = content.replace(/<script>/g, "<<span class='code_js'>script</span>>");
	content = content.replace(/<\/script>/g, "<<span>/</span><span class='code_js'>script</span>>");
	return content;
};
utils.remindModel = function(msg) {
	var box = '<div class="ww_model_msg">' + msg + '</div><span class="ww_hidden">*</span>';
	if($(".ww_model_msg").length > 0) {
		$(".ww_model_msg").html(msg);
	} else {
		$(".ww_model_remind").append(box);
	}
};

utils.checkEmail = function checkEmail(account) {
	var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
	if(reg.test(account)) {
		return true;
	} else {
		return false;
	}
};
utils.search = {
	click: function() {
		var keyword = $("input[name='keyword']").val();
		var searchWord = localStorage.getItem("searchWord");
		if(keyword != "") {
			if(searchWord != null) {
				var items = searchWord.split(";");
				var isSame = false;
				$.each(items, function(k, v) {
					if(v == keyword) {
						isSame = true;
					}
				});
				if(!isSame) {
					if(items.length == 5) {
						items[4] = keyword;
						localStorage.setItem("searchWord", items.join(";"));
					} else {
						localStorage.setItem("searchWord", searchWord + ";" + keyword);
					}
				}
			} else {
				localStorage.setItem("searchWord", keyword);
			}
			utils.search.find(keyword);
		} else {
			return;
		}
	},
	itemClick: function() {
		var keyword = $(this).text();
		utils.search.find(keyword);
	},
	close: function() {
		$(".blog-search-board").removeClass("active");
	},
	find: function(keyword) {
		$.ajax({
			url: "/search/article",
			data: {
				keyword: keyword
			},
			beforeSend: function(xhr) {
				$(".blog-search-container .loading-area").show();
			},
			success: function(data) {
				var data = eval('(' + data + ')');
				var ret = data.ret;
				if(ret == "0") {
					var html = '';
					var lists = data.article;
					for(var i = 0; i < lists.length; i++) {
						html += '<div class="blog-article-item"><div class="blog-article-intro">';
						html += '<p class="blog-article-date"><a class="blog-article-author" >';
						html += lists[i].ky_user_name + '</a>&nbsp;&nbsp;·&nbsp;&nbsp;' + utils.checkDate(lists[i].ky_publish_date) + ' </p>';
						html += '<h4><a href="/article/page/id/' + lists[i].ky_article_id + '" target="_blank">';
						html += utils.htmlspecialchars_decode(lists[i].ky_article_title) + '</a></h4>';
						html += '<div class="blog-article-detail">' + lists[i].ky_article_content + '</div>';
						html += '<div class="blog-article-data"><a href="/article/page/id/' + lists[i].ky_article_id + '" target="_blank">阅读 ' + lists[i].ky_article_read + '</a>';
						//						html += ' <a href="/article/page/id/' + lists[i].ky_article_id + '/#comment" target="_blank">评论 ' + lists[i].ky_article_topic + '</a> · 喜欢 ' + lists[i].ky_article_love;
						html += '<a class="blog-article-read" href="/article/page/id/' + lists[i].ky_article_id + '" target="_blank">阅读全文</a></div>';
						html += '</div></div>';
					}
					if(lists.length <= 0) {
						html = '<div style="padding:10px">抱歉，没有找到与<span style="color:red">' + keyword
						+ '</span>相关的结果。</br>建议您尝试变换检索词，或者去<a href="baidu.com" target="_blank" style="color:blue">百度一下</a></div>';
					}
					$(".blog-search-container .blog-article-con").eq(0).html(html);
					$(".blog-search-container .loading-area").hide();

					var newSubject = data.subject;
					var subjects = [];
					for(var i = 0; i < newSubject.length; i++) {
						var html = '<li><a class="fl subject-img" href="/subject/page/id/' + newSubject[i].ky_subject_id + '">';
						html += '<img  src="' + newSubject[i].ky_subject_headimg + '" alt="' + newSubject[i].ky_subject_id + '"></a>';
						html += '<div class="subject-info"><h5>';
						html += '<a href="/subject/page/id/' + newSubject[i].ky_subject_id + '">' + newSubject[i].ky_subject_title + '</a>';
						html += '</h5><div class="btn follow">';
						html += '<a class="blog-add-attention" data-subject-id="' + newSubject[i].ky_subject_id + '">';
						html += '<span class="fa fa-plus"></span><span>添加关注</span></a></div>';
						html += '<p class="description">' + newSubject[i].ky_subject_content + '</p><p>';
						html += '<a class="blue-link" href="/subject/page/id/' + newSubject[i].ky_subject_id + '">' + newSubject[i].ky_article_num + '篇文章</a>'
						// + checkMath(parseInt(newSubject[i].ky_subject_follow)) + '人关注';
						html += '<span class="tag"></span></p></div></li>';
						subjects.push(html);
					}
					if(newSubject.length <= 0) {
						html = '<div style="padding:10px">抱歉，没有找到与<span  style="color:red">' + keyword
						+ '</span>相关的结果。</br>建议您尝试变换检索词，或者去<a href="baidu.com" target="_blank" style="color:blue">百度一下</a></div>';
						$(".blog-search-container .blog-article-con").eq(1).html("<ul class='blog-subject-box'>" + html + "</ul>");
					} else {
						$(".blog-search-container .blog-article-con").eq(1).html("<ul class='blog-subject-box'>" + subjects.join("") + "</ul>");
					}
				}
				$('pre code').each(function(i, block) {
					hljs.highlightBlock(block);
				});
			},
			error: function(err) {

			}
		});
	}
};
utils.scroll = {
	scrollTo: function() {
		$("html,body").animate({
			scrollTop: "0px"
		}, 1000);
	},
	scrollEvent: function() {
		if($(window).scrollTop() != 0) {
			$(".blog-gotop").css({
				"display": "block"
			});
		} else {
			$(".blog-gotop").css({
				"display": "none"
			});
		}
	}
};

utils.input = {
	searchInputFocus: function() {
		var searchWord = localStorage.getItem("searchWord");
		$(".blog-search-list").empty();
		if(searchWord != null) {
			var items = searchWord.split(";");
			$.each(items, function(i, v) {
				$(".blog-search-list").prepend("<li>" + v + "</li>");
			});
		}
		$(".blog-search-list").show();
	},
	searchInputBlur: function() {
		setTimeout(function() {
			$(".blog-search-list").hide();
		}, 200);
	}
};

Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份   
		"d+": this.getDate(), //日   
		"h+": this.getHours(), //小时   
		"m+": this.getMinutes(), //分   
		"s+": this.getSeconds(), //秒   
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度   
		"S": this.getMilliseconds() //毫秒   
	};
	if(/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	};

	for(var k in o) {
		if(new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	};
	return fmt;
};

window.utils = utils;